import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import AboutMeComponent from './AboutMeComponent/AboutMeComponent.react.js';
import ProjectOverview from './ProjectOverview/ProjectOverview.react.js';
import ContactOverview from './ContactOverview/ContactOverview.react.js';
import CanvasComponent from './CanvasComponent/CanvasComponent.react.js';
import Sidebar from './Sidebar/Sidebar.react.js';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isResized: false
    }
  }

  render() {
    const imageReq = require.context("./images", false, /\.png$/);
    const url = imageReq(`./portrait.png`);

    return (
      <div className="App">
        <CanvasComponent></CanvasComponent>
        <Sidebar onChange={this.onChange.bind(this)}>
          <div className="sbTop">
            <div className="sbTitle seperator">
              <h3>Alexander Prost</h3>
              <span>Webentwickler</span>
            </div>
            <div className="photo" style={{backgroundImage: "url(" + url + ")"}}></div>
          </div>
          <div className="sbBottom">
            <ul>
              <li>
                <div className="btnContainer2">
                  <div className="btnContent2">
                    <div className="btn2Left"></div>
                    <div className="btn2Right"></div>
                    <a href="#about">Über mich</a>
                  </div>
                </div>
              </li>
              <li>
                <div className="btnContainer2">
                  <div className="btnContent2">
                    <div className="btn2Left"></div>
                    <div className="btn2Right"></div>
                    <a href="#projects">Projekte</a>
                  </div>
                </div>
              </li>
              <li>
                <div className="btnContainer2">
                  <div className="btnContent2">
                    <div className="btn2Left"></div>
                    <div className="btn2Right"></div>
                    <a href="#contact">Kontakt</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="footer">
            <a href="https://codepen.io/Viket/"><i className="fa fa-codepen" aria-hidden="true"></i><span className="sHide">Codepen</span></a>
            <a href="https://gitlab.com/VIK3T"><i className="fa fa-gitlab" aria-hidden="true"></i><span className="sHide">Gitlab</span></a>
          </div>
        </Sidebar>
        <AboutMeComponent>
          
        </AboutMeComponent>
        <ProjectOverview isResized={this.state.isResized}>
        </ProjectOverview>
        <ContactOverview>

        </ContactOverview>
      </div>
    );
  }

  onChange(args) {
    this.setState({
      isResized: true
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js